import { render, staticRenderFns } from "./vFormRADIOBUTTONS.vue?vue&type=template&id=dc483f66&"
import script from "./vFormRADIOBUTTONS.vue?vue&type=script&lang=js&"
export * from "./vFormRADIOBUTTONS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports